import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as theme from "../theme";
import Switch from '@material-ui/core/Switch';

const UserData = () => {
  return (
    <UserDataPane></UserDataPane>
  );
};

const UserDataPane = () => {
  return (
    <div
      style={{
        margin: "3.5rem",
        marginTop: "3rem",
        marginBottom: "50vh",
      }}
    >
      <div>
        <h5 class="px-2" style={{fontFamily: "GibsonSemiBd",
              justifyContent: "center",
              fontSize: "1.2vw",}}>Quotey will make it super easy for you to extract your data.  This is just a placeholder while we build this functionality for you.</h5>
      </div>
    </div>
  );
};

export default UserData;
